import { render, staticRenderFns } from "./Focuses.vue?vue&type=template&id=5bf034cd&scoped=true&"
import script from "./Focuses.vue?vue&type=script&lang=js&"
export * from "./Focuses.vue?vue&type=script&lang=js&"
import style0 from "./Focuses.vue?vue&type=style&index=0&id=5bf034cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf034cd",
  null
  
)

export default component.exports